






































import { Component, Vue } from "vue-property-decorator";
import { serialiseConfig } from "@/helpers/table";
import { FilterOperators, Sorters } from "@/data/table";
import { TicketStatusCodes } from "@/data/enums/tickets";
import { ITicket } from "@/models/tickets";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";

@Component({
  components: {
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue"),
    "remote-access-control": () =>
      import("@/components/app/admin/upmind/remoteAccessControl.vue")
  }
})
export default class AdminAccountTickets extends Vue {
  public breadcrumbs: ICrumb[] = [
    {
      label: this.$t("_.my_upmind"),
      route: {
        to: {
          name: "admin__upmindAccount"
        }
      }
    }
  ];

  public get routes() {
    return [
      {
        label: this.$t("_.active_tickets"),
        exact: true,
        to: { name: "admin__upmindSupport" }
      },
      {
        label: this.$t("_.closed_tickets"),
        exact: true,
        to: {
          name: "admin__upmindSupport",
          query: {
            TT1: serialiseConfig({
              constFilters: [
                {
                  key: "status.code",
                  operator: FilterOperators.EQUAL,
                  value: TicketStatusCodes.CLOSED
                }
              ],
              sort: {
                field: "updated_at",
                direction: Sorters.DESCENDING
              }
            })
          }
        }
      }
    ];
  }

  public get tableProps() {
    return {
      rowProps: (ticket: ITicket) => ({
        to: { name: "admin__upmindTicket", params: { ticketId: ticket.id } }
      })
    };
  }
}
